import router from '@/router';
import { iStoreCaseConfiguration } from '@/Interfaces/storeCaseConfiguration';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { sendConfig } from '@/utils/postmessages';
import { useStoreMeta } from '@/Store/storeMeta';

export function updateUrlOnStoreChange(store: iStoreCaseConfiguration) {
    if (!store || !store.caseItems) return;
    if (useStoreMeta().projectId) return;

    let config = '';
    for (const item of store.caseItems) {
        if (item.isDefaultHolder) continue;
        config += '|' + item.prototypeId + '/' + item.isLeft;
        if (item.indexPositionY !== undefined) config += '/' + item.indexPositionY;
        if (item.indexPositionX !== undefined) config += '/' + item.indexPositionX;
        if (item.idGroup !== undefined) config += 'id' + item.idGroup;
    }

    if (!config.length && !store.blenderName) return;

    let exDPrId = '|';
    store.expandedDrawersPrototypeId.forEach(x => exDPrId += (x + '|'));
    let dS = '|';
    store.drawerSeparators.forEach(x => {
        dS += (x.prototypeId + '/' + x.drawerPrototypeId + '/' + x.count + '|');
    });

    const toolChest = `|bn${store.blenderName}|clrFrame${store.colorFrame.replace('#', '')}|clrFace${store.colorFace.replace('#', '')}|drClose${store.isCloseDoors}|exDPrId${exDPrId}|dS${dS}`;
    sendConfig(config, toolChest);
    console.log('redirect to configurator');
    router.replace({
        path: '/configurator',
        query: {
            config: config,
            toolChest: toolChest,
        },
    });
}
